import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

import Icon from '../../../../components/common/Icon';
import { useMetronomeStore } from '../plugins/MetronomePlugin/MetronomePlugin';

import { ReactComponent as MetronomeIcon } from '../../../../icons/metronome-solid.svg';

import './PartTempoMarker.scss';

/**
 *    .---------.
 *   (  /\  120  )
 *    '---------'
 */
const PartTempoMarker = ({ toBpm, timeSignature, atFoot = false, onTap }) => {
  const { t } = useTranslation();
  const isActive = useMetronomeStore((state) => state.activeMetronomeId !== null && Number(state.activeBpm) === toBpm);

  const handleClick = (e) => {
    // Keeps the tap off the part's own handlers; a second tap is ViewBody's double-tap
    e.stopPropagation();
    if (e.detail >= 2) return;
    onTap(toBpm, timeSignature);
  };

  const content = (
    <>
      <Icon icon={<MetronomeIcon aria-hidden="true" />} className="solid metronome" />
      <span className="bpm">{toBpm}</span>
    </>
  );

  return (
    <span className={cx('PartTempoMarker', { 'at-foot': atFoot })}>
      {onTap ? (
        <button
          type="button"
          className={cx('pill', { active: isActive })}
          aria-label={isActive ? t('view.stopMetronome') : t('view.playMetronomeAt', { bpm: toBpm })}
          aria-pressed={isActive}
          onClick={handleClick}
        >
          {content}
        </button>
      ) : (
        <span className="pill">{content}</span>
      )}
    </span>
  );
};

PartTempoMarker.propTypes = {
  toBpm: PropTypes.number.isRequired,
  timeSignature: PropTypes.string,
  /** At the end of the part, in place of its closing blank line, so it needs room from the last line */
  atFoot: PropTypes.bool,
  /** Given the BPM to play and the time signature. Without it the marker is read-only */
  onTap: PropTypes.func,
};

export default PartTempoMarker;
